<template>
  <div class="video-page-box">
    <breadcrumb :breadcrumb="config.breadcrumb" />

    <div class="video-page">
      <div class="video-page-left">
        <el-input placeholder="设备名称" v-model="filterKey"
                  class="video-device-input" size="small" />
        <!--<the-tree title="设备列表" keyName="设备名称" class="filter-tree"-->
        <!--:filterKey="filterText" :maxDepth="4"-->
        <!--@selected="handleSelected" :options="treeOptions"-->
        <!--/>-->
        <el-tree ref="videoTree" default-expand-all
                 :data="videoTreeData"
                 :filter-node-method="filterNode"
                 :render-content="renderContent"
                 :expand-on-click-node="false"
                 @node-click="handleNodeClick"
                 class="video-device-tree"
        />
      </div>

      <div class="video-page-right">
        <!--<div class="video-page-right-top"></div>-->
        <div class="video-page-right-main">
          <!--<div class="video-page-right-main-line" v-for="line in videoLineNumber" >-->
            <!--<div ref="DHVideoPlayer" class="video-page-right-main-box video-page-right-main-box-choose DHVideoPlayer" v-for="box in videoLineBoxNumber" @click="chooseVideoBox(line, box)" :id="`${line}-${box}`"></div>-->
          <!--</div>-->

          <div class="video-page-right-main-line" >
            <HlsVideo v-if="previewProtocolType === '大华云睿' && videoUrl" :videoUrl="videoUrl" class="video-page-right-main-box-choose DHVideoPlayer" />
            <HKPlayer v-if="previewProtocolType === '海康云眸' && hkVideoPlayerLink" :hkVideoPlayerLink="hkVideoPlayerLink" />
<!--            <div v-show="previewProtocolType === '大华云睿'" ref="DHVideoPlayer" class="video-page-right-main-box video-page-right-main-box-choose DHVideoPlayer" ></div>-->
<!--            <iframe-->
<!--              v-if="previewProtocolType === '海康云眸' && isPlayHKVideo"-->
<!--              :src="hkVideoPlayerLink"-->
<!--              width="100%"-->
<!--              height="100%"-->
<!--              id="ysOpenDevice"-->
<!--              allowfullscreen>-->
<!--            </iframe>-->
          </div>
        </div>
      </div>


      <el-dialog title="温馨提示" :visible.sync="dHVideoDialogVisible" width="40%">
        <p style="padding: 20px 0;text-align: center;">此视频需下载并安装播放软件才可播放,安装好后若无法播放,请刷新页面 </p>
        <p style="padding: 20px 0;text-align: center;"><a href="https://yq.damaiiot.com/yq/DHPlayerSetup.exe" download="DHPlayerSetup.exe" style="margin-left: 20px;color: #00a0e6;">请点击此处下载</a></p>
        <span slot="footer" class="dialog-footer">
          <!--<el-button @click="dHVideoDialogVisible = false" size="mini">稍后观看</el-button>-->
          <el-button type="primary" @click="dHVideoDialogVisible = false" size="small">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>

</template>

<script>
import { api } from "../../api/VideoServices";
import TheTree from "../../../components/Tree/the-tree";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import { nError } from "../../../utils/notice";
import "../../../tool/videoPlayer";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import DHPlayer from "../../../components/DHPlayer/DHPlayer";
import HKPlayer from "../../../components/HKPlayer/HKPlayer";
import HlsVideo from "../../../components/HlsVideo/HlsVideo";

var oVideoControl = null;
var initCount = 0;

export default {
  components: {
    HlsVideo,
    HKPlayer,
    DHPlayer,
    TheTree,
    Breadcrumb
  },
  name: "video-page",
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: "智慧监控",
            name: "video-device"
          },
          {
            value: "视频图像"
          }
        ]
      },
      treeClickCount: 0,
      filterKey: "",
      videoTreeData: [],
      videoLineNumber: 1,
      videoLineBoxNumber: 1,

      previewProtocolType: "",
      isPlayHKVideo: true,

      chooseVideoLineNumber: null,
      chooseVideoLineBoxNumber: null,

      dHVideoDialogVisible: false,

      dHPreviewToken: "",
      previewDeviceCode: "",
      currentPlaybackDeviceCode: "",

      hkVideoPlayerLink: "",
      videoUrl: ""
    };
  },
  created() {
    window.sessionStorage.setItem("noDhVideo", "0");
    // this.videoTreeData = [{
    //   label: 'all',
    //   code: '0',
    //   children: [
    //     {
    //       label: '111',
    //       code: '1',
    //     }
    //   ]
    // }]
    this.getVideoList();
  },
  mounted() {},
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      this.hkVideoPlayerLink = "";
      this.videoUrl = "";
      // if (data.disabled) {
      //   nError('设备离线，无法观看')
      //   return
      // } else {
      //
      // }

      // if (data.deviceType === '11') {
      //   this.preview(data)
      // } else {
      //   this.previewStream(data)
      // }
      this.treeClickCount++;
      //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
      if (this.treeClickCount >= 2) {
        return;
      }
      //计时器,计算300毫秒为单位,可自行修改
      this.timer = window.setTimeout(() => {
        if (this.treeClickCount === 1) {
          //把次数归零
          this.treeClickCount = 0;
          //单击事件处理
          this.preview(data);
        } else if (this.treeClickCount > 1) {
          //把次数归零
          this.treeClickCount = 0;
          // 双击预览
          this.preview(data);
          // setTimeout(() => {
          //   let noDhVideo = window.sessionStorage.getItem('noDhVideo')
          //   console.log(noDhVideo)
          //   if (noDhVideo === '1') {
          //     this.dHVideoDialogVisible = true
          //   } else {
          //     this.realmonitor('5L0D009PAG2C70A', 'Ut_00006b37ea0c632549d286f17315a23a', '0')
          //     setTimeout(() => {
          //       this.stopPreview()
          //     }, 10000)
          //   }
          // }, 2000)
        }
      }, 500);
    },

    chooseVideoBox(line, box) {
      this.chooseVideoLineNumber = line;
      this.chooseVideoLineBoxNumber = box;
    },

    // 获取视频设备
    getVideoList() {
      this.$axios
        .post(`${api.getVideoDeviceList}`, {})
        .then(res => {
          let data = res.data.data;
          data.map(v => {
            v.label = v.deviceName;
            v.code = v.deviceCode;
            if (v.deviceStatus === "1") {
              v.className = "video-device-online";
            } else if (v.deviceStatus === "0") {
              v.className = "video-device-offline";
            }
            // if (v.deviceType === '11') {
            //   v.deviceTypeText = '摄像头'
            // } else if (v.deviceType === '12') {
            //   v.deviceTypeText = '平台'
            // }
          });
          this.videoTreeData = [
            {
              label: bus.global.yqName,
              code: "0",
              children: data
            }
          ];
        })
        .catch(errorHandler("查询失败"));
    },

    renderContent(h, { node, data, store }) {
      let _class = data.className;
      return (
        <span class="video-device-line">
          <i class={_class} />
          <span class="left" title={data.label}>
            {data.label}
          </span>
        </span>
      );
    },

    // 查询通道
    getChannel(deviceCode, protocolType) {
      this.$axios
        .post(`${api.getChannel}`, {
          deviceCode: deviceCode
        })
        .then(res => {
          let data = res.data.data;
          data.map(v => {
            v.label = v.deviceName;
            v.code = v.deviceCode;
            v.protocolType = protocolType;
          });
          let videoTreeData = this.videoTreeData;
          videoTreeData[0].children.map(video => {
            if (video.code === deviceCode) {
              video.children = data;
            }
          });
          this.videoTreeData = videoTreeData;
          console.log(this.videoTreeData);
        })
        .catch(errorHandler("查询通道失败"));
    },

    // 预览
    preview(row) {
      let deviceName = row.deviceName;
      let deviceCode = row.deviceCode;
      let protocolType = row.protocolType;
      this.previewDeviceName = deviceName;
      this.previewDeviceCode = deviceCode;
      this.previewProtocolType = protocolType;
      this.dHPreviewToken = "";
      let url = "";
      if (protocolType === "大华云睿") {
        url = `${api.getVideoHlsStream}`;
      } else {
        url = `${api.preview}`;
      }
      // 如果是摄像头设备，直接查询rtmp流
      this.$axios
        .post(url, { deviceCode: deviceCode })
        .then(res => {
          let data = res.data.data;
          if (data) {
            if (protocolType === "大华云睿") {
              this.videoUrl = data.hls;
            } else if (protocolType === "海康云眸") {
              this.isPlayHKVideo = true;
              let token = data;
              let channelNum = row.deviceId;
              this.hkVideoPlayerLink = `https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/${deviceCode}/${channelNum ||
                "1"}.live&autoplay=1&accessToken=${token}`;
              setTimeout(() => {
                this.isPlayHKVideo = false;
              }, 120000);
              // this.play(token, deviceCode)
            } else {
              let videoUrl = data.split(",");
              this.options.source = videoUrl[0];
              let timestamp = new Date().getTime();
              this.aliplayerId = `${bus.global.yqCode}${timestamp} `;
              console.log(this.options);
              this.dialogVisible = true;
            }
          } else {
            nError("预览失败");
          }
        })
        .catch(errorHandler("预览失败"));
    },

    // 通道预览
    previewStream(row) {
      this.dHPreviewToken = "";
      this.$axios
        .post(`${api.previewStream}`, {
          streamId: row.streamId,
          deviceCode: row.deviceCode
        })
        .then(res => {
          let data = res.data.data;
          if (data) {
            if (row.protocolType === "大华云睿") {
              let token = data;
              this.dHPreviewToken = token;
              this.dHPreviewDeviceId = parseInt(row.streamId);
              this.previewDeviceCode = row.deviceCode;
              this.currentPlaybackDeviceCode = row.deviceCode;
            } else {
            }
          } else {
            nError("预览失败");
          }
        })
        .catch(errorHandler("预览失败"));
    }
  },
  watch: {
    filterKey(val) {
      this.$refs.videoTree.filter(val);
    }
  }
};
</script>

<!--<style>-->
  <!--.video-device-tree .el-tree-node__content {-->
    <!--background-color: #333333!important;-->
  <!--}-->
  <!--.video-device-tree .el-tree-node__content:hover {-->
    <!--background-color: #666666!important;-->
  <!--}-->
<!--</style>-->

<style lang="less">
.video-page-box {
  width: 100%;
  height: 100%;
  padding: 0 0 0 20px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  .video-page {
    flex: 1;
    width: 100%;
    height: 100%;
    min-height: 600px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #ffffff;
    .video-page-left {
      width: 20%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      border-right: 1px solid #666666;
      .video-device-input {
        /*background-color: #333333;*/
        /*color: #ffffff;*/
      }
      .video-device-tree {
        overflow-y: auto;
        flex: 1;
        padding-top: 8px;
        /*background-color: #333333;*/
        /*color: #ffffff;*/
      }
    }
    .video-page-right {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      background-color: #333333;
      .video-page-right-top {
        width: 100%;
        height: 40px;
      }
      .video-page-right-main {
        flex: 1;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .video-page-right-main-line {
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .video-page-right-main-box {
            flex: 1;
            width: 100%;
            height: 100%;
            border: 1px solid #666666;
          }
          .video-page-right-main-box-choose {
            border: 1px solid #ee781b;
          }
        }
      }
    }

    .el-tree-node__content:hover {
      /*background-color: #666666;*/
    }

    #DHVideoPlayer {
      width: 100% !important;
      height: 100% !important;
    }
  }

  .video-device-line {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .video-device-online {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: #67c23a;
  }
  .video-device-offline {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: #f56c6c;
  }
  .left {
    flex: 1;
    display: block;
    text-align: left;
    min-width: 100px;
    line-height: 25px;
    max-width: 145px;
    margin-left: 3px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    user-select: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/VideoServices/VideoPage/VideoPage.vue